import { _request,APIBaseResponse, APIMethod } from '../index';
import { RequestParamsBase } from '../Models/CommonRequestModels';

const TENANTS_PATH_PREFIX = '/tenants';
const USER_CLAIM_MEMBERSHIP_PATH_PREFIX = 'userclaimmemberships';

type APIUserClaimMembershipListParams = RequestParamsBase & {
    tenantId: string;
    userId: string;
};

type APIUserClaimMembershipDeleteParams = {
    tenantId: string;
    userId: string;
    claimId: string;
};

type APIUserClaimMembershipListResponse = APIBaseResponse<Array<{
    claimId: string;
    userId: string;
    claimName: string;
}>>;

export type APIUserClaimMembershipPostParams = {
    tenantId: string;
    userId: string;
    claimId: string;
    value: string;
}

export type APIUserClaimMembershipPostResponse = APIBaseResponse;

export type APIUserClaimMembershipPutParams = {
    tenantId: string;
    userId: string;
    claimId: string;
    value: string;
};

export type APIUserClaimMembershipPutResponse = APIBaseResponse;

export const APIUserClaimMembershipGetList: APIMethod<APIUserClaimMembershipListParams, APIUserClaimMembershipListResponse> = params => (
    _request('GET', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_CLAIM_MEMBERSHIP_PATH_PREFIX}?userId=${params.userId}`, undefined, params.signal)
);

export const APIUserClaimMembershipPost: APIMethod<APIUserClaimMembershipPostParams, APIUserClaimMembershipPostResponse> = params => (
    _request('POST', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_CLAIM_MEMBERSHIP_PATH_PREFIX}`, params)
);

export const APIUserClaimMembershipPut: APIMethod<APIUserClaimMembershipPutParams, APIUserClaimMembershipPutResponse> = params => (
    _request('PUT', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_CLAIM_MEMBERSHIP_PATH_PREFIX}`, params)
);

export const APIUserClaimMembershipDelete: APIMethod<APIUserClaimMembershipDeleteParams, APIBaseResponse> = params => (
    _request('DELETE', `${TENANTS_PATH_PREFIX}/${params.tenantId}/${USER_CLAIM_MEMBERSHIP_PATH_PREFIX}?userId=${params.userId}&claimId=${params.claimId}`)
);
